<template lang='pug'>
v-dialog(:model-value='show' @update:model-value='!$event ? emit("clicked", "cancel") : null' :persistent="persistent" max-width="600" width="auto" eager location="top" scrim="true")
	.tw-white-card.tw-flex.tw-flex-col.tw-items-center.tw-justify-center.tw-gap-2.tw-px-10.tw-py-6
		v-progress-circular(v-if="loading" indeterminate)
		v-icon.tw-text-4xl(v-if='messageType && "error" == messageType || "warning" == messageType' icon="mdi mdi-alert" color='warning')
		v-icon(v-else-if='icon' :icon="icon" :color='iconColor')
		div.tw-font-bold {{ title }}
		p(v-if="text" :class="'text-' + textColor + ' text-' + textAlign") {{ text }}
		div(v-if="textHTML" v-html="textHTML")
		.tw-flex.tw-items-center.tw-justify-between.tw-gap-2.tw-mt-5(v-if="showCancel || showNo || showOK")
			v-btn(v-if="showCancel" @click='emit("clicked", "cancel")') {{btnCancelText || $t('common.cancel', 'Annulla')}}
			v-btn(v-if="showNo" @click='emit("clicked", "no")' color="red") {{btnNoText || $t('common.no', 'No')}}
			v-btn(v-if="showOK" @click='emit("clicked", "ok")' color="primary-darken-1") {{btnOKText || $t('common.ok', 'OK')}}
</template>
	
<script setup>
import { computed } from "vue";
import {useI18n} from "vue-i18n";

const i18n = useI18n();
const emit = defineEmits(['clicked']);
const props = defineProps({
	show: {
		type: Boolean,
		default: true
	},
	persistent: {
		type: Boolean,
		default: false
	},
	title: String,
	titleColor: {
		type: String,
		default: 'inherit'
	},
	titleAlign: {
		type: String,
		default: 'left'
	},
	text: String,
	textColor: {
		type: String,
		default: 'inherit'
	},
	textAlign: {
		type: String,
		default: 'left'
	},
	textHTML: String,
	loading: {
		type: Boolean,
		default: false
	},
	showCancel: {
		type: Boolean,
		default: false
	},
	btnCancelText: {
		type: String,
		default: null
	},
	CancelColorButton: {
		type: String,
		default: 'red'
	},
	showOK: {
		type: Boolean,
		default: true
	},
	btnOKText: {
		type: String,
		default: null
	},
	OkColorButton: {
		type: String,
		default: 'primary-darken-1'
	},
	showNo: {
		type: Boolean,
		default: false
	},
	btnNoText: {
		type: String,
		default: null
	},
	messageType: String, // example "error"

	loadingColor: {
		type: String,
		default: 'primary-darken-1'
	},
});

const icon = computed(() => {
	if(props.messageType == 'warning') return 'mdi-alert';
	return null;
});

const iconColor = computed(() => {
	if(props.messageType == 'warning') return 'accent';
	return 'primary-darken-1';
});
</script>